import { assertUnreachable } from '../../helpers/TypescriptHelpers';
import { IContentAndLuidInfo } from '../../mappers/DatabaseAndTableMapper';
import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../services/RestApiService';
import { TaggableCatalogTypes, TaggableCatalogTypesRestApiVersion, Tags } from './CatalogContentTags';

type SetTagsRequestBody = Tags;

export type SetTagsResponse = {};

export type SetCatalogContentTagsParam = Pick<IContentAndLuidInfo, 'luid' | 'tags'> & TaggableCatalogTypes;

export async function setCatalogContentTags(item: SetCatalogContentTagsParam): Promise<SetTagsResponse | void> {
  if (!item.tags || item.tags.length < 1) {
    return;
  }

  switch (item.contentType) {
    case 'database':
      return setDatabaseTags(item);
    case 'table':
      return setTableTags(item);
    default:
      assertUnreachable(item.contentType);
  }
}

function setDatabaseTags(item: SetCatalogContentTagsParam) {
  const config: JsonRestApiRequestConfig = {
    restApiVersion: TaggableCatalogTypesRestApiVersion,
    serverWideRequest: false,
    httpMethod: 'PUT',
    endpoint: `databases/${item.luid}/tags`,
  };

  const request = mapItemToRequest(item);
  return makeJsonRestApiRequest<SetTagsRequestBody, {}>({ config, request });
}

function setTableTags(item: SetCatalogContentTagsParam) {
  const config: JsonRestApiRequestConfig = {
    restApiVersion: TaggableCatalogTypesRestApiVersion,
    serverWideRequest: false,
    httpMethod: 'PUT',
    endpoint: `tables/${item.luid}/tags`,
  };

  const request = mapItemToRequest(item);
  return makeJsonRestApiRequest<SetTagsRequestBody, {}>({ config, request });
}

function mapItemToRequest(item: SetCatalogContentTagsParam): SetTagsRequestBody {
  return {
    tags: {
      tag: item.tags.map(label => { return { label }; })
    }
  };
}
